<div *ngIf="label" [class.disabled]="disabled" class="control-label">
  {{label | translate}}<span *ngIf="isRequired" class="text-danger"> * </span>
  </div>
<div class="timepicker-wrapper" (click)="onClick($event)" (appClickOutside)="closeTimePicker()">
  <div class="form-control"
       [class.form-control--open]="showTimepicker && !isError"
       [class.form-control--disabled]="disabled"
       [class.form-control--error]="isError">
    <ng-container *ngIf="_value">
      {{ _value | date: 'shortTime' }}
    </ng-container>
    <ng-container *ngIf="!_value">
      <span class="timepicker-wrapper__placeholder">
        {{ placeholder }}
      </span>
    </ng-container>
  </div>
  <span class="time-icon icon-clock-16"
  [class.disabled-opacity]="disabled"></span>
  <app-timepicker-popup
  (click)="$event.stopPropagation()"
  [minuteStep]="minuteStep"
  [showMeridian]="showMeridian"
  [isDisabled]="disabled"
  [initTime]="_value"
  [(ngModel)]="_value"
  (ngModelChange)="value = $event"
  (timepickerValueChanged)="onValueChanged($event)"
  class="timepicker"
  *ngIf="showTimepicker"></app-timepicker-popup>
</div>
<div class="invalid-text" *ngIf="(control?.touched && control?.invalid) || isError">{{errorMessage}}</div>
